import { Box, useColorModeValue } from '@chakra-ui/react';

/** Plain section break — no label (keeps homepage rhythm without tiny divider text). */
export function PreviewSectionDivider() {
  const lineColor = useColorModeValue('gray.300', 'whiteAlpha.150');

  return (
    <Box py={{ base: 4, md: 6 }} aria-hidden>
      <Box h="1px" bg={lineColor} />
    </Box>
  );
}
